import React from "react";
import styles from "./beneficiary.module.css";
import Button from "../../Common/Button";
import { maskAccountNo, formatAmountWithDecimal } from "../../../src/Constants/helper";
import {getTransferDetails} from "../../../src/utils/utils";

const TransferStep2 = ({
  amount,
  remarks,
  lienAccountNo,
  unlienAccountNo,
  name,
  transferMethod = "Borderless Instant",
  transferFee = "Free",
  transferPurpose = "Lien Release",
  transferOn,
  onBack,
  onConfirm,
  loading = false,
  extraDetails = [],
  transferType = "UNLIEN",
}) => {
  const baseDetails = getTransferDetails({
    name,
    transferMethod,
    remarks,
    transferOn,
    transferFee,
    transferPurpose,
    extraDetails,
    transferType,
  });

  return (
    <div className={styles.lienTransferForm}>
      <div className={styles.formScrollArea}>
        <div className={styles.amountBox}>
          <div className={styles.amountLabel}>
            {transferType === "EMI" ? "Deduction Amount" : "Amount"}
          </div>
          <div className={styles.amountValue}>
            {formatAmountWithDecimal(amount)}
          </div>
        </div>
        {transferType !== "EMI" && (
          <div className={styles.accountTransferRow}>
            <div className={styles.accountBox}>
              <div className={styles.accountLabel}>Lien account no:</div>
              <div className={styles.accountNo}>
                {maskAccountNo(lienAccountNo)}
              </div>
            </div>
            <div className={styles.arrowIcon}>→</div>
            <div className={styles.accountBox}>
              <div className={styles.accountLabel}>Unlien account no:</div>
              <div className={styles.accountNo}>
                {maskAccountNo(unlienAccountNo)}
              </div>
            </div>
          </div>
        )}
        <div className={styles.detailsTable}>
          {baseDetails.map((item, idx) => (
            <div key={idx} className={styles.detailRow}>
              <div className={styles.detailLabel}>{item.label}</div>
              <div
                className={`${styles.detailValue} ${
                  item.isGreen ? styles.greenText : ""
                }`}
              >
                {item.value || "—"}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.formFooter}>
        <div className={styles.footerRow}>
          <div className={styles.footerCol}>
            <Button onClick={onBack} title="Back" disabled={loading} />
          </div>
          <div className={styles.footerCol}>
            <Button
              onClick={onConfirm}
              title="Confirm Transfer"
              loading={loading}
              disabled={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferStep2;
